// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../../../../../Config.bs.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as PickupDropCmp from "./PickupDrop/PickupDropCmp.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ConfirmOrderCmp from "./ConfirmOrder/ConfirmOrderCmp.bs.js";
import * as VehicleDetailsSM from "../../app/state-machine/VehicleDetailsSM.bs.js";
import * as ConfirmOrderFbCmp from "./shared/ConfirmOrderFbCmp.bs.js";
import * as PlaceOrderContext from "../context/PlaceOrderContext.bs.js";
import * as PlaceOrderMapHelper from "../../app/helper/PlaceOrderMapHelper.bs.js";
import * as RestrictionBoundsSM from "../../app/state-machine/RestrictionBoundsSM.bs.js";
import * as VehicleQuotationsSM from "../../app/state-machine/VehicleQuotationsSM.bs.js";
import * as VehicleSelectionCmp from "./VehicleSelection/VehicleSelectionCmp.bs.js";
import * as PlaceOrderDataMachine from "../../app/data-machine/PlaceOrderDataMachine.bs.js";
import * as Api from "@react-google-maps/api";
import * as VehicleQuotationPayload from "../../app/api-model/VehicleQuotationPayload.bs.js";
import * as PlaceOrderStepsController from "./PlaceOrderStepsController.bs.js";
import * as UnRestrictedVehiclesVmMapper from "../vm-mapper/UnRestrictedVehiclesVmMapper.bs.js";

function PlaceOrderCmp(Props) {
  var onClosePlaceOrderPanel = Props.onClosePlaceOrderPanel;
  var match = PlaceOrderContext.useContext(undefined);
  var state = match.state;
  var wayPointThree = state.wayPointThree;
  var wayPointTwo = state.wayPointTwo;
  var wayPointOne = state.wayPointOne;
  var isRebook = state.isRebook;
  var customerInfo = state.customerInfo;
  var geo_region = state.geo_region;
  var selectedVehicle = state.selectedVehicle;
  var dropAddress = state.dropAddress;
  var pickupAddress = state.pickupAddress;
  var currentStep = state.currentStep;
  var dispatch = match.dispatch;
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var match$2 = React.useReducer(RestrictionBoundsSM.machine, /* Init */0);
  var restrictionBoundDispatch = match$2[1];
  var restrictionBoundState = match$2[0];
  var match$3 = React.useReducer(VehicleDetailsSM.reducer, /* Init */0);
  var vehicleDetailsDispatch = match$3[1];
  var match$4 = React.useReducer(VehicleQuotationsSM.reducer, /* Init */0);
  var vehicleQuotationsDispatch = match$4[1];
  var vehicleQuotations = match$4[0];
  var setVehicle = function (vehicles, quotations) {
    var unrestrictedVehiclesVM = UnRestrictedVehiclesVmMapper.getVM(vehicles.vehicles.on_demand, quotations);
    return Caml_option.undefined_to_opt(unrestrictedVehiclesVM.find(function (e) {
                    return e.vehicle_id === selectedVehicle.vehicle_id;
                  }));
  };
  var handleRestrictedVehicles = function (location_type, latLng, restrictionBounds) {
    restrictionBounds.forEach(function (e) {
          switch (location_type) {
            case "Drop" :
                var match = e.polygon;
                if (typeof match === "number") {
                  return ;
                }
                switch (match.TAG | 0) {
                  case /* PickUp */0 :
                      return ;
                  case /* Drop */1 :
                  case /* Both */2 :
                      break;
                  
                }
                if (PlaceOrderMapHelper.isCoordsUnderPolygon(match._0, latLng)) {
                  return Curry._1(dispatch, {
                              TAG: /* SetRestrictedVehicleIds */10,
                              _0: e.vehicle_ids
                            });
                } else {
                  return ;
                }
            case "PickUp" :
                var match$1 = e.polygon;
                if (typeof match$1 === "number") {
                  return ;
                }
                switch (match$1.TAG | 0) {
                  case /* Drop */1 :
                      return ;
                  case /* PickUp */0 :
                  case /* Both */2 :
                      break;
                  
                }
                if (PlaceOrderMapHelper.isCoordsUnderPolygon(match$1._0, latLng)) {
                  return Curry._1(dispatch, {
                              TAG: /* SetRestrictedVehicleIds */10,
                              _0: e.vehicle_ids
                            });
                } else {
                  return ;
                }
            default:
              return ;
          }
        });
    
  };
  var setRestrictedVehicleIds = function (restrictionBounds) {
    var pickup = pickupAddress.latLng;
    if (pickup !== undefined) {
      handleRestrictedVehicles("PickUp", pickup, restrictionBounds);
    }
    Belt_List.toArray(Belt_List.keepMap({
                hd: wayPointOne.address.latLng,
                tl: {
                  hd: wayPointTwo.address.latLng,
                  tl: {
                    hd: wayPointThree.address.latLng,
                    tl: {
                      hd: dropAddress.latLng,
                      tl: /* [] */0
                    }
                  }
                }
              }, (function (x) {
                  return x;
                }))).forEach(function (e) {
          return handleRestrictedVehicles("Drop", e, restrictionBounds);
        });
    
  };
  var getRestrictionBounds = function (id) {
    Curry._1(restrictionBoundDispatch, /* SetToLodingState */0);
    return PlaceOrderDataMachine.fetchRestrictionBounds(String(id), country, (function (data) {
                  if (isRebook) {
                    setRestrictedVehicleIds(data);
                  }
                  return Curry._1(restrictionBoundDispatch, {
                              TAG: /* FetchRestrictionBoundsSuccess */0,
                              _0: data
                            });
                }), (function (error) {
                  return Curry._1(restrictionBoundDispatch, {
                              TAG: /* FetchRestrictionBoundsFailed */1,
                              _0: error
                            });
                }));
  };
  var fetchVehicleDetails = function (param) {
    var v = pickupAddress.latLng;
    return PlaceOrderDataMachine.fetchVehicleDetails(geo_region !== undefined ? String(geo_region.id) : "", v !== undefined ? v : ({
                    lat: 0.00,
                    lng: 0.00
                  }), customerInfo.mobile, country, (function (vehicles) {
                  Curry._1(vehicleDetailsDispatch, {
                        TAG: /* FetchVehicleDetailsSuccess */0,
                        _0: vehicles
                      });
                  Curry._1(dispatch, {
                        TAG: /* SetVehicles */11,
                        _0: vehicles.vehicles
                      });
                  Curry._1(dispatch, {
                        TAG: /* ChangeCurrentStep */0,
                        _0: /* ConfirmOrderStep */2
                      });
                  var vehicleIds = vehicles.vehicles.vehicle_ids;
                  var payload = VehicleQuotationPayload.getData(undefined, state, vehicleIds);
                  return PlaceOrderDataMachine.fetchVehicleQuotation(payload, country, (function (data) {
                                var v = setVehicle(vehicles, data);
                                if (v !== undefined) {
                                  Curry._1(vehicleQuotationsDispatch, {
                                        TAG: /* FetchVehicleQuotationsSuccess */0,
                                        _0: data
                                      });
                                  Curry._1(dispatch, {
                                        TAG: /* SetSelectedVehicle */2,
                                        _0: v
                                      });
                                  if (geo_region !== undefined) {
                                    return getRestrictionBounds(geo_region.id);
                                  } else {
                                    return ;
                                  }
                                } else {
                                  return Curry._1(vehicleQuotationsDispatch, {
                                              TAG: /* FetchVehicleQuotationsFailed */1,
                                              _0: /* DefaultError */{
                                                _0: {
                                                  title: /* Unauthorized */1,
                                                  message: "Something Went Wrong!"
                                                }
                                              }
                                            });
                                }
                              }), (function (error) {
                                return Curry._1(vehicleQuotationsDispatch, {
                                            TAG: /* FetchVehicleQuotationsFailed */1,
                                            _0: error
                                          });
                              }));
                }), (function (error) {
                  return Curry._1(vehicleDetailsDispatch, {
                              TAG: /* FetchVehicleDetailsFailed */1,
                              _0: error
                            });
                }));
  };
  React.useEffect((function () {
          if (isRebook || geo_region === undefined) {
            
          } else {
            getRestrictionBounds(geo_region.id);
          }
          if (isRebook) {
            fetchVehicleDetails(undefined);
          }
          
        }), []);
  var fallBackCmp = function (param) {
    return React.createElement(ConfirmOrderFbCmp.make, {});
  };
  var errorCmp = function (param) {
    return React.createElement("p", undefined, "Something went wrong!");
  };
  var tmp;
  if (isRebook) {
    var exit = 0;
    var tmp$1 = match$3[0];
    if (typeof tmp$1 === "number") {
      tmp = fallBackCmp(undefined);
    } else if (tmp$1.TAG === /* Data */0 && typeof vehicleQuotations !== "number") {
      tmp = vehicleQuotations.TAG === /* Data */0 ? (
          typeof restrictionBoundState === "number" || restrictionBoundState.TAG !== /* Data */0 ? fallBackCmp(undefined) : React.createElement(ConfirmOrderCmp.make, {
                  onClosePlaceOrderPanel: onClosePlaceOrderPanel
                })
        ) : errorCmp(undefined);
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp = typeof vehicleQuotations === "number" ? fallBackCmp(undefined) : errorCmp(undefined);
    }
    
  } else {
    switch (currentStep) {
      case /* PickupDropStep */0 :
          tmp = React.createElement(PickupDropCmp.make, {
                getRestrictionBounds: getRestrictionBounds,
                restrictionBoundState: restrictionBoundState,
                handleRestrictedVehicles: handleRestrictedVehicles
              });
          break;
      case /* VehicleSelectionStep */1 :
          tmp = React.createElement(VehicleSelectionCmp.make, {});
          break;
      case /* ConfirmOrderStep */2 :
          tmp = React.createElement(ConfirmOrderCmp.make, {
                onClosePlaceOrderPanel: onClosePlaceOrderPanel
              });
          break;
      
    }
  }
  return React.createElement(Api.LoadScriptNext, {
              googleMapsApiKey: Config.Env.getGoogleMapsApiKey(undefined),
              id: "load-script",
              libraries: Config.Env.placeOrderGMapsLibrary,
              children: null
            }, React.createElement(PlaceOrderStepsController.make, {
                  currentStep: currentStep
                }), React.createElement("div", {
                  className: "place-order-steps-content"
                }, tmp));
}

var make = PlaceOrderCmp;

export {
  make ,
  
}
/* react Not a pure module */
